var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigcontact5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_6537)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.9658,
    y1: 120.093,
    x2: 17.9658,
    y2: -21.4222,
    stroke: "url(#paint0_linear_75_6537)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.9658,
    y1: 120.093,
    x2: 52.9658,
    y2: -21.4222,
    stroke: "url(#paint1_linear_75_6537)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.9658,
    y1: 120.093,
    x2: 88.9658,
    y2: -21.4222,
    stroke: "url(#paint2_linear_75_6537)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.966,
    y1: 120.093,
    x2: 124.966,
    y2: -21.4222,
    stroke: "url(#paint3_linear_75_6537)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.966,
    y1: 120.093,
    x2: 160.966,
    y2: -21.4222,
    stroke: "url(#paint4_linear_75_6537)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.966,
    y1: 120.093,
    x2: 195.966,
    y2: -21.4222,
    stroke: "url(#paint5_linear_75_6537)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.966,
    y1: 120.093,
    x2: 231.966,
    y2: -21.4222,
    stroke: "url(#paint6_linear_75_6537)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 18.954,
    x2: 258.387,
    y2: 18.954,
    stroke: "url(#paint7_linear_75_6537)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 77.954,
    x2: 258.387,
    y2: 77.954,
    stroke: "url(#paint8_linear_75_6537)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 47.954,
    x2: 258.387,
    y2: 47.954,
    stroke: "url(#paint9_linear_75_6537)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.125,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "url(#paint10_linear_75_6537)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8046 45.2308C60.5873 45.0248 60.2994 44.91 60 44.91C59.7007 44.91 59.4127 45.0248 59.1955 45.2308C55.8857 48.374 51.4775 50.0976 46.9135 50.0332C46.6648 50.03 46.4216 50.1061 46.2192 50.2505C46.0168 50.3949 45.8656 50.6 45.7877 50.8362C45.1297 52.8416 44.7955 54.9391 44.7976 57.0497C44.7976 66.3146 51.1343 74.0967 59.7085 76.303C59.8997 76.3523 60.1004 76.3523 60.2916 76.303C68.8658 74.0967 75.2024 66.3146 75.2024 57.0497C75.2024 54.8824 74.8547 52.793 74.2123 50.8362C74.1347 50.5998 73.9837 50.3942 73.7812 50.2495C73.5788 50.1048 73.3354 50.0285 73.0866 50.0316L72.8636 50.0332C68.1922 50.0332 63.9495 48.2089 60.8046 45.2308ZM65.6288 57.7295C65.7224 57.6049 65.7901 57.4628 65.8279 57.3116C65.8658 57.1604 65.873 57.0031 65.8492 56.8491C65.8254 56.6951 65.7711 56.5474 65.6894 56.4146C65.6077 56.2819 65.5003 56.1668 65.3735 56.0762C65.2467 55.9856 65.1031 55.9212 64.951 55.8869C64.799 55.8525 64.6417 55.849 64.4882 55.8763C64.3348 55.9037 64.1884 55.9614 64.0576 56.0462C63.9268 56.131 63.8142 56.241 63.7266 56.3699L58.6809 63.4332L56.1488 60.901C55.9271 60.6944 55.6339 60.582 55.3309 60.5873C55.0279 60.5926 54.7389 60.7154 54.5246 60.9296C54.3104 61.1439 54.1876 61.4329 54.1823 61.7359C54.177 62.0389 54.2894 62.3321 54.496 62.5537L58.0042 66.062C58.1243 66.182 58.269 66.2743 58.4283 66.3328C58.5877 66.3912 58.7578 66.4142 58.9269 66.4002C59.096 66.3863 59.2601 66.3357 59.4077 66.252C59.5553 66.1683 59.683 66.0534 59.7817 65.9154L65.6288 57.7295Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.125,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "url(#paint11_linear_75_6537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.527 212.625V197.669H17.1161V212.625H19.527ZM24.1704 212.625V207.134C24.1704 204.723 25.2642 203.473 27.6974 203.473C29.9967 203.473 30.9342 204.522 30.9342 206.598V212.625H33.3451V205.95C33.3451 203.383 31.8271 201.307 28.7466 201.307C25.9339 201.307 24.4606 203.093 24.1257 204.968H23.9695V201.53H21.7595V212.625H24.1704ZM40.7392 212.848C43.8644 212.848 45.9182 211.62 45.9182 209.544C45.9182 207.714 44.7127 206.821 42.0786 206.486L39.5115 206.129C37.8372 205.906 37.3908 205.593 37.3908 204.723C37.3908 203.673 38.1051 203.227 40.1365 203.227C42.592 203.227 43.2617 203.919 43.2617 205.236V205.37H45.6503V205.303C45.6503 202.669 43.5966 201.307 40.2035 201.307C36.7881 201.307 35.0246 202.691 35.0246 204.633C35.0246 206.486 36.297 207.379 38.3953 207.647L41.4312 208.049C43.0162 208.272 43.5519 208.562 43.5519 209.477C43.5519 210.46 42.9046 210.906 40.7392 210.906C38.4176 210.906 37.5471 210.437 37.5471 208.986V208.808H35.1362V208.875C35.1362 211.442 37.1676 212.848 40.7392 212.848ZM52.2784 212.848C55.1358 212.848 56.6091 211.062 56.9663 209.187H57.1002V212.625H59.3102V201.53H56.9216V207.022C56.9216 209.433 55.7832 210.683 53.3276 210.683C50.9837 210.683 50.0238 209.634 50.0238 207.558V201.53H47.6353V208.205C47.6353 210.772 49.1532 212.848 52.2784 212.848ZM63.9113 212.625V206.397C63.9113 204.41 64.6926 203.361 66.5901 203.361C68.242 203.361 68.9117 204.098 68.9117 205.683V206.665H71.3002V205.214C71.3002 203.115 70.2064 201.307 67.6839 201.307C65.407 201.307 64.2015 202.736 63.8667 204.522H63.7104V201.53H61.5004V212.625H63.9113ZM76.0737 212.848C78.5962 212.848 80.3597 211.732 80.9401 209.857H81.0963V212.625H83.3063V205.883C83.3063 203.227 81.7214 201.307 78.1943 201.307C74.6673 201.307 72.569 203.205 72.569 205.727V205.817H74.9575V205.727C74.9575 204.098 75.9621 203.428 78.0158 203.428C80.1364 203.428 80.9401 204.075 80.9401 205.906V206.553L75.8951 207.089C73.7074 207.334 72.3234 208.227 72.3234 209.946C72.3234 211.777 73.7744 212.848 76.0737 212.848ZM74.7343 209.79C74.7343 208.919 75.337 208.629 76.5871 208.473L80.9401 207.982C80.9401 210.169 79.2435 211.107 76.721 211.107C75.337 211.107 74.7343 210.683 74.7343 209.79ZM87.8692 212.625V207.134C87.8692 204.723 88.9631 203.473 91.3963 203.473C93.6955 203.473 94.6331 204.522 94.6331 206.598V212.625H97.044V205.95C97.044 203.383 95.526 201.307 92.4455 201.307C89.6328 201.307 88.1594 203.093 87.8246 204.968H87.6683V201.53H85.4584V212.625H87.8692ZM104.795 212.848C108.121 212.848 110.555 210.973 110.555 208.205V207.96H108.166V208.116C108.166 209.835 106.916 210.683 104.751 210.683C102.25 210.683 101.134 209.477 101.134 207.089C101.134 204.656 102.25 203.473 104.751 203.473C106.916 203.473 108.166 204.321 108.166 206.04V206.174H110.555V205.95C110.555 203.182 108.121 201.307 104.795 201.307C101.134 201.307 98.7458 203.629 98.7458 207.089C98.7458 210.504 101.134 212.848 104.795 212.848ZM117.918 212.848C121.222 212.848 123.544 211.219 123.544 208.852V208.652H121.133V208.83C121.133 210.147 120.173 210.906 117.851 210.906C115.284 210.906 114.235 209.768 114.146 207.625H123.566C123.633 207.29 123.655 206.977 123.655 206.575C123.655 203.205 121.311 201.307 117.874 201.307C114.257 201.307 111.891 203.629 111.891 207.089C111.891 210.795 114.28 212.848 117.918 212.848ZM117.829 203.205C120.195 203.205 121.378 204.187 121.378 206.241V206.285H114.168C114.302 204.299 115.373 203.205 117.829 203.205Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_6537",
    x1: 18.4658,
    y1: -1.34432,
    x2: 18.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_6537",
    x1: 53.4658,
    y1: -1.34432,
    x2: 53.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_6537",
    x1: 89.4658,
    y1: -1.34432,
    x2: 89.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_6537",
    x1: 125.466,
    y1: -1.34432,
    x2: 125.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_6537",
    x1: 161.466,
    y1: -1.34432,
    x2: 161.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_6537",
    x1: 196.466,
    y1: -1.34432,
    x2: 196.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_6537",
    x1: 232.466,
    y1: -1.34432,
    x2: 232.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_6537",
    x1: 0,
    y1: 19.454,
    x2: 255.154,
    y2: 19.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_6537",
    x1: 0,
    y1: 78.454,
    x2: 255.154,
    y2: 78.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_75_6537",
    x1: 0,
    y1: 48.454,
    x2: 255.154,
    y2: 48.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_75_6537",
    x1: 60,
    y1: 16.625,
    x2: 60,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_75_6537",
    x1: 60,
    y1: 16.625,
    x2: 60,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6537"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigcontact5);
export default __webpack_public_path__ + "static/media/bigcontact5.527c2cff6e620321fb13aff3ff9edbb5.svg";
export { ForwardRef as ReactComponent };